module.exports = __webpack_public_path__ + "static/media/client6.82614831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/client6.png
// module id = 302
// module chunks = 0